import { render, staticRenderFns } from "./addPatientService2.vue?vue&type=template&id=b37c1e12&"
import script from "./addPatientService2.vue?vue&type=script&lang=js&"
export * from "./addPatientService2.vue?vue&type=script&lang=js&"
import style0 from "./addPatientService2.vue?vue&type=style&index=0&id=b37c1e12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports